var render = function render(_c, _vm) {
  return _c(
    "span",
    _vm._g(
      _vm._b(
        {
          class: [
            ..._vm.$options.classes(_vm.props),
            _vm.data.staticClass,
            _vm.data.class
          ],
          style: [
            ..._vm.$options.styles(_vm.props),
            _vm.data.staticStyle,
            _vm.data.style
          ]
        },
        "span",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }